import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  BasicInformationStyles: {
    display: "flex",
    gap: "32px",
    padding: "12px 0",
    fontFamily: "'Inter', sans-serif",
  },
  leftColumn: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    minWidth: "160px",
  },
  avatarWrapper: {
    position: "relative",
    width: "120px",
    height: "120px",
    marginBottom: "12px",
  },
  avatarImg: {
    width: "120px",
    height: "120px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #f1f5f9",
  },
  editIconOverlay: {
    position: "absolute",
    bottom: "4px",
    right: "4px",
    backgroundColor: "#1a1a1a",
    color: "#fff",
    borderRadius: "50%",
    width: "30px",
    height: "30px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
    transition: "background-color 0.2s",
    "&:hover": {
      backgroundColor: "#333",
    },
    "& svg": {
      fontSize: "15px",
    },
  },
  photoLabel: {
    fontSize: "13px !important",
    fontWeight: "600 !important",
    color: "#1a1a1a",
    fontFamily: "'Inter', sans-serif !important",
  },
  photoSubLabel: {
    fontSize: "11px !important",
    color: "#94a3b8",
    fontFamily: "'Inter', sans-serif !important",
    textAlign: "center",
  },
  rightColumn: {
    flex: 1,
  },
  formLabel: {
    display: "block",
    fontSize: "13px",
    fontWeight: "500",
    color: "#374151",
    marginBottom: "6px",
    fontFamily: "'Inter', sans-serif",
  },
  formInput: {
    "& .MuiOutlinedInput-root": {
      borderRadius: "8px",
      fontFamily: "'Inter', sans-serif",
      fontSize: "14px",
      backgroundColor: "#fff",
      "& fieldset": {
        borderColor: "#e5e7eb",
      },
      "&:hover fieldset": {
        borderColor: "#9ca3af",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#6b7280",
        borderWidth: "1px",
      },
    },
    "& .MuiInputBase-input::placeholder": {
      color: "#9ca3af",
      opacity: 1,
    },
  },
  phoneRow: {
    display: "flex",
    gap: "8px",
    alignItems: "flex-start",
  },
  countryCodeWrapper: {
    minWidth: "130px",
  },
}));

export default useStyles;
